import {Role} from './Role';
import {LanguageModel} from '../../translation/translation.models';
import {InvoiceDealer} from '../../back-office/Models/InvoiceDealer';
import {Country} from './Country';
import {DealerType} from '../../back-office/Models/DealerType';
import {DeliveryContact} from '../../back-office/Models/DeliveryContact';

export class SystemUser {
  static SYSTEMUSER_ACTIVE = 'active';
  static SYSTEMUSER_ON_HOLD = 'on_hold';
  static SYSTEMUSER_INACTIVE = 'inactive';
  static PREMIUM_STORES = 'doctrine.user.premium_stores';
  static XXL_STORES = 'doctrine.user.xxl_stores';
  static REGULAR_STORES = 'doctrine.user.regular_stores';
  public id: number;
  public firstName: string;
  public lastName: string;
  public email: string;
  public phone: string;
  public username: string;
  public password: string;
  public status: string;
  public role: Role | number;
  public roles?: Role[];
  public companyName: string;
  public city: string;
  public contact: string;
  public companyPhone: string;
  public companyEmail: string;
  public language?: number | LanguageModel;
  public invoiceDealer?: InvoiceDealer;
  public debtorString: string;
  public address: string;
  public website: string;
  public zipCode: string;
  public country?: Country;
  public employee?: SystemUser[];
  public dealerPoints: number;
  public dealerType: DealerType;
  public isAllowedPartialPaid: boolean;
  public disabled?: boolean;
  public deliveryContact?: DeliveryContact;
  public secondaryDeliveryContact?: DeliveryContact;
  public defaultDelivery = 'primary';
  public parent: any;
  public isCustomerAccount: boolean;
}
